// extracted by mini-css-extract-plugin
export default {"additional-first":"frDiZ","additional-second":"Xb3eH","additional-third":"BZBb9","additional-block":"eN97x","button":"b6HhF","expand-button":"HPjhv"};